import { Grid, Typography } from "@mui/material";
import styles from "../ServicesMenu/services.module.scss";
import CONSTANTS from "../../config/constants.json";
import { color } from "html2canvas/dist/types/css/types/color";

const YoungadultOverview = () => {
  return (
    <div className={styles.youngadultOverview}>
      <Grid className={styles.cardContainer}>
        <Grid>
          <Typography className={styles.heading}>Overview</Typography>

          <Grid>
            <Typography className={styles.summary}>
              The Hindu Community and Cultural Center introduced{" "}
              <span style={{color:"#000",fontWeight:"700",fontSize:"18px" }}>Young Adults Committee</span> aimed at meeting the needs of
              individuals aged 18-32 within our community. This initiative is
              designed to assist young adults in achieving their social and
              career objectives, while also providing exposure to Hindu religion
              and culture through periodic Q&A sessions and volunteer
              opportunities. The objective is to foster self-confidence, promote
              success in both careers and relationships, navigate cross-cultural
              dynamics within our communities, lead fulfilling lives, and
              contribute positively to the community.
            </Typography>
          </Grid>
          <Typography className={styles.heading}>Mission Statement</Typography>
          <Typography className={styles.summary}>
            Build the next-generation platform of young adults shaped by the
            Hindu Community and Cultural Center's heritage and values while
            advancing interests in career counseling, professional networking,
            and mental and spiritual well-being.
          </Typography>
        </Grid>
        <Grid>
          <Typography className={styles.heading}>Young Adults Team</Typography>
        </Grid>

        <Typography className={styles.header}>
          Dimple Cyril - Executive Committee Chairperson
        </Typography>
        <Typography className={styles.header}><a href="mailto:ec_young_adults@livermoretemple.org">ec_young_adults@livermoretemple.org</a></Typography>
        <br />
        <Typography className={styles.details}>
          <span className={styles.summary}><a href="https://hints20.livermoretemple.org/hints/youngadults/2024/HCCC_YoungAdults_VolunteerCampaign_01.01.24.pdf" target="_blank">Click here</a></span> Young Adults Volunteer Campaign
        </Typography>
        <Typography className={styles.details}>
          <span className={styles.summary}><a href="https://hints20.livermoretemple.org/hints/youngadults/2024/HCCCYoungAdults_MentoringProgram_Teaser.pdf" target="_blank">Click here</a></span> Young Adults Mentoring Program
          
        </Typography>
        <Typography className={styles.details}>
          <span className={styles.summary}><a href="https://hints20.livermoretemple.org/hints/youngadults/2024/YoungAdultServices.pdf" target="_blank">Click here</a></span> Young Adult Services
          
        </Typography>
      </Grid>
    </div>
  );
};
export default YoungadultOverview;
